document.addEventListener('DOMContentLoaded', function () {
  function termAndConditions() {
    setTimeout(() => {
      const submitButton = document.querySelector('.buy-buttons button[type="submit"]');
      const termsCheckbox = document.querySelector('.terms-and-conditions-checkbox');
      
      if (!submitButton || !termsCheckbox) {
        return; // Exit if elements don't exist
      }

      const termsChecked = termsCheckbox.checked;

      if (!termsChecked) {
        submitButton.setAttribute('name', 'checkout-terms');
        submitButton.title = 'Du skal acceptere vilkårene og betingelserne for at kunne fortsætte';
      }

      termsCheckbox.addEventListener('change', function () {
        const termsChecked = this.checked;

        submitButton.setAttribute('name', termsChecked ? 'checkout' : 'checkout-terms');
        submitButton.title = termsChecked ? 'Du skal acceptere vilkårene og betingelserne for at kunne fortsætte' : 'Gå til betaling';
      });
    }, 1000);
  }

  termAndConditions();
  document.addEventListener('cart:change', termAndConditions);
});

document.addEventListener('DOMContentLoaded', function () {
  // Add a special CSS class when the cart-icon is clicked 
  const cartIcon = document.querySelector("#cart-icon");
  if (cartIcon) {
    cartIcon.addEventListener("click", function(){
      document.body.classList.toggle("js-show-ajax-cart");
      // Close all quick buy drawers when cart opens
      if (document.body.classList.contains("js-show-ajax-cart")) {
        closeAllQuickBuyDrawers();
      }
    });
  }
});

// Close cart when clicking on the overlay
function closeCart() {
  document.body.classList.toggle("js-show-ajax-cart");
}

// Function to close all quick buy drawers
function closeAllQuickBuyDrawers() {
  const quickBuyDrawers = document.querySelectorAll('quick-buy-drawer[open]');
  quickBuyDrawers.forEach(drawer => {
    drawer.removeAttribute('open');
  });
}

// Make functions available globally
window.closeCart = closeCart;
window.closeAllQuickBuyDrawers = closeAllQuickBuyDrawers;

// Watch for cart opening and close quick buy drawers automatically
document.addEventListener('DOMContentLoaded', function() {
  // Use MutationObserver to watch for class changes on body
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (document.body.classList.contains('js-show-ajax-cart')) {
          closeAllQuickBuyDrawers();
        }
      }
    });
  });
  
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
});

// Listen for the "liquid-ajax-cart:request-end" event which is fired
// after a Shopify Cart API Ajax request is performed
document.addEventListener('liquid-ajax-cart:request-end', event => {
  const {requestState} = event.detail;

  // If the "add to cart" request is successful
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    // Add the CSS class to the "body" tag
    document.body.classList.add('js-show-ajax-cart');
    
    // Close all quick buy drawers when cart opens
    closeAllQuickBuyDrawers();

    // Check if js-ajax-cart-empty is not present on the HTML tag
    const cartRecommendations = document.querySelector("#shopify-section-cart-recomendations");
    if (!document.documentElement.classList.contains("js-ajax-cart-empty") && cartRecommendations) {
      setTimeout(function(){
        cartRecommendations.classList.add("cart-recom-slidein");
      }, 500);
    } else if (cartRecommendations) {
      cartRecommendations.classList.remove("cart-recom-slidein");
    }
  }
});

// terms and conditions with popup
document.addEventListener('DOMContentLoaded', function() {
  let modal = document.getElementById("terms-modal");
  let acceptButton = document.getElementById("accept-terms");

  if (!modal || !acceptButton) return; // Exit if elements don't exist

  document.body.addEventListener('click', function(event) {
    let target = event.target;
    let nameAttr = target.getAttribute('name');
    
    if (nameAttr === 'checkout' || nameAttr === 'goto_pp' || nameAttr === 'goto_gc') {
      let agreeCheckbox = document.getElementById('agree');
    
      if (agreeCheckbox && agreeCheckbox.checked) {
        target.form.submit();
      } else {
        modal.style.display = "block";
        event.preventDefault();
      }
    }
  });

  acceptButton.onclick = function() {
    modal.style.display = "none";
    var agreeCheckbox = document.getElementById('agree');
    if (agreeCheckbox) {
      agreeCheckbox.checked = true;
    }

    // Redirect to the checkout page
    window.location.href = '/checkout';
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
});

// cart instructions dropdown
function toggleCartInstructions() {
  var dropdown = document.getElementById('cartInstructionDropdown');
  var arrow = document.getElementById('arrow');
  if (dropdown && arrow) {
    if (dropdown.classList.contains('hidden')) {
        dropdown.classList.remove('hidden');
        arrow.classList.remove('arrow-down');
        arrow.classList.add('arrow-up');
    } else {
        dropdown.classList.add('hidden');
        arrow.classList.remove('arrow-up');
        arrow.classList.add('arrow-down');
    }
  }
}

// PRODUCT ITEM 
document.addEventListener("DOMContentLoaded", function () {
  const colorContainer = document.querySelector(".color_container");
  const productItems = document.querySelectorAll(".Product-item");

  if (colorContainer) {
    const colorLinks = colorContainer.querySelectorAll(".color_link");
    const activeColor = colorContainer.querySelector(".active_color");
    const activeColorName = activeColor ? activeColor.querySelector(".color_name") : null;

    if (activeColorName) {
      colorLinks.forEach(link => {
        if (link !== activeColor) {
          link.addEventListener("mouseenter", () => {
            activeColorName.classList.add("hidden");
          }); 

          link.addEventListener("mouseleave", () => {
            activeColorName.classList.remove("hidden");
          });
        }
      });
    }
  }

  if (productItems.length > 0) {
    productItems.forEach(item => {
      const colorLinks = item.querySelectorAll(".color_link");
      const activeColorItem = item.querySelector(".active_color");
      const activeColorNameItem = activeColorItem ? activeColorItem.querySelector(".color_name") : null;

      colorLinks.forEach(link => {
        const linkColorName = link.querySelector(".color_name");

        if (linkColorName) {
          link.addEventListener("mouseenter", () => {
            if (activeColorNameItem) {
              activeColorNameItem.classList.add("hidden");
            }

            if (link !== activeColorItem) {
              linkColorName.classList.remove("hidden");
            }
          });

          link.addEventListener("mouseleave", () => {
            if (activeColorNameItem) {
              activeColorNameItem.classList.remove("hidden");
            }

            if (link !== activeColorItem) {
              linkColorName.classList.add("hidden");
            }
          });
        }
      });
    });
  }

  document.addEventListener('liquid-ajax-cart:request-end', event => {
    const {requestState} = event.detail;
  
    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
  
      // Add the CSS class to the "body" tag
      document.body.classList.add('js-show-ajax-cart');
      closeAllQuickBuyDrawers();
    }
  });
});

// Unified Preorder System - Global Implementation
window.UnifiedPreorderSystem = {
  pending: false,
  pendingRequestState: null,
  cancelled: false,
  initialized: false,
  
  init: function() {
    if (this.initialized) return;
    

    // Intercept ALL liquid-ajax-cart requests with highest priority
    document.addEventListener('liquid-ajax-cart:request-start', (event) => {
      this.handleCartRequest(event);
    }, { capture: true });

    // ALSO intercept all form submissions that might not go through liquid-ajax-cart
    document.addEventListener('submit', (event) => {
      this.handleFormSubmission(event);
    }, { capture: true });

    this.initialized = true;
  },

  handleFormSubmission: function(event) {
    const form = event.target;
    
    // Only handle product forms
    if (!form.matches('form[action*="/cart/add"]') && 
        form.getAttribute('is') !== 'product-form' &&
        !form.closest('ajax-cart-product-form')) {
      return;
    }

    if (this.pending || this.cancelled) {
      return;
    }


    const formData = new FormData(form);
    const isAddingPreorder = formData.get('properties[_preorder]') === 'true';
    

    // ALWAYS prevent default first, then check asynchronously
    event.preventDefault();
    event.stopImmediatePropagation();

    // Get current cart state
    this.getCurrentCart().then(cart => {

      if (this.shouldShowPopup(isAddingPreorder, cart)) {
        
        const requestData = this.convertFormDataToObject(formData);
        this.showPopup(isAddingPreorder, requestData, 'form-submission');
      } else {
        // No conflict, submit the form normally
        this.submitFormNormally(form, formData);
      }
    });

    return false;
  },

  submitFormNormally: function(form, formData) {
    // Use liquid-ajax-cart if available, otherwise use native fetch
    if (window.liquidAjaxCart) {
      const requestData = this.convertFormDataToObject(formData);
      window.liquidAjaxCart.add(requestData, {
        lastCallback: (addRequestState) => {
          if (addRequestState.responseData && !addRequestState.responseData.message) {
            document.body.classList.add('js-show-ajax-cart');
            closeAllQuickBuyDrawers();
          } else {
            console.error('UnifiedPreorderSystem: Error adding product:', addRequestState.responseData?.message);
          }
        }
      });
    } else {
      // Fallback to native form submission
      fetch(form.action, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        document.body.classList.add('js-show-ajax-cart');
        closeAllQuickBuyDrawers();
        // Optionally refresh cart UI here
      })
      .catch(error => {
        console.error('UnifiedPreorderSystem: Error in fallback submission:', error);
      });
    }
  },

  handleCartRequest: function(event) {
    const { requestState } = event.detail;
    
    
    // ONLY block ADD requests when popup should be shown
    if (requestState.requestType !== 'add' || this.pending || this.cancelled) {
      return;
    }

    const requestBody = requestState.requestBody;
    const isAddingPreorder = this.isPreorderProduct(requestBody);

    // Get current cart state
    this.getCurrentCart().then(cart => {

      if (this.shouldShowPopup(isAddingPreorder, cart)) {
        
        event.preventDefault();
        event.stopImmediatePropagation();
        requestState.info.cancel = true;

        const requestData = requestBody instanceof FormData ? 
          this.convertFormDataToObject(requestBody) : 
          JSON.parse(JSON.stringify(requestBody));

        this.showPopup(isAddingPreorder, requestData, 'ajax-request');
        return false;
      }
    });
  },

  getCurrentCart: function() {
    return new Promise((resolve) => {
      // Try liquid-ajax-cart first
      if (window.liquidAjaxCart && window.liquidAjaxCart.cart) {
        resolve(window.liquidAjaxCart.cart);
        return;
      }

      // Fallback to fetch cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => resolve(cart))
        .catch(() => resolve({ items: [] }));
    });
  },

  showPopup: function(isPreorder, requestData, sourceType = 'unknown') {
    console.log(`UnifiedPreorderSystem: Showing popup for ${sourceType}, isPreorder: ${isPreorder}`);

    this.pendingRequestState = {
      requestBody: requestData,
      isPreorder: isPreorder,
      sourceType: sourceType
    };

    if (isPreorder) {
      // Adding preorder to cart with regular items - show main popup
      const popup = document.getElementById('unified-preorder-popup');
      if (popup) {
        popup.classList.remove('hidden');
        this.attachPopupListeners();
      }
    } else {
      // Adding regular product to cart with preorders - show reverse popup
      const reversePopup = document.getElementById('reverse-preorder-popup');
      if (reversePopup) {
        reversePopup.classList.remove('hidden');
        this.attachPopupListeners();
      }
    }
  },

  attachPopupListeners: function() {
    // Remove any existing listeners to prevent duplicates
    const confirmBtn = document.getElementById('unified-confirm-preorder');
    const cancelBtn = document.getElementById('unified-cancel-preorder');
    const reverseConfirmBtn = document.getElementById('reverse-confirm-regular');
    const reverseCancelBtn = document.getElementById('reverse-cancel-preorder');
    const popup = document.getElementById('unified-preorder-popup');
    const reversePopup = document.getElementById('reverse-preorder-popup');

    if (confirmBtn) confirmBtn.onclick = () => this.confirmAction(true);
    if (cancelBtn) cancelBtn.onclick = () => this.cancelAction();
    if (reverseConfirmBtn) reverseConfirmBtn.onclick = () => this.confirmAction(false);
    if (reverseCancelBtn) reverseCancelBtn.onclick = () => this.cancelAction();
    
    if (popup) {
      popup.onclick = (e) => {
        if (e.target === popup) this.cancelAction();
      };
    }
    
    if (reversePopup) {
      reversePopup.onclick = (e) => {
        if (e.target === reversePopup) this.cancelAction();
      };
    }
  },

  isPreorderProduct: function(requestBody) {
    
    if (requestBody instanceof FormData) {
      const isPreorderFromForm = requestBody.get('properties[_preorder]') === 'true';
      return isPreorderFromForm;
    } else if (requestBody.items) {
      const isPreorderFromItems = requestBody.items.some(item => 
        item.properties && item.properties._preorder === 'true'
      );
      return isPreorderFromItems;
    } else if (requestBody.properties) {
      const isPreorderFromProps = requestBody.properties._preorder === 'true';
      return isPreorderFromProps;
    }
    
    return false;
  },

  shouldShowPopup: function(isAddingPreorder, cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return false;
    }

    // If adding preorder, show popup if cart has any regular (non-preorder) items
    if (isAddingPreorder) {
      const hasRegular = cart.items.some(item => !item.properties || item.properties._preorder !== 'true');
      return hasRegular;
    } else {
      // If adding regular, show popup if cart has any preorder items
      const hasPreorder = cart.items.some(item => item.properties && item.properties._preorder === 'true');
      return hasPreorder;
    }
  },

  convertFormDataToObject: function(formData) {
    const id = formData.get('id');
    const quantity = formData.get('quantity') || 1;
    const items = [{
      id: id ? parseInt(id) : undefined,
      quantity: parseInt(quantity),
      properties: {}
    }];
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[')) {
        const propKey = key.replace('properties[', '').replace(']', '');
        items[0].properties[propKey] = value;
      }
    }
    // Remove properties if empty
    if (Object.keys(items[0].properties).length === 0) {
      delete items[0].properties;
    }
    console.log('UnifiedPreorderSystem: convertFormDataToObject', { items });
    return { items: items };
  },

  confirmAction: function(isPreorder) {
    if (!this.pendingRequestState || this.pending) return;

    this.pending = true;

    this.addProductAfterClear(this.pendingRequestState.requestBody);
    this.hidePopup();
    this.resetState();
  },

  cancelAction: function() {
    console.log('UnifiedPreorderSystem: Cancel action');
    this.cancelled = true;
    this.hidePopup();
    
    setTimeout(() => {
      this.resetState();
    }, 100);
  },

  hidePopup: function() {
    const popup = document.getElementById('unified-preorder-popup');
    const reversePopup = document.getElementById('reverse-preorder-popup');
    if (popup) popup.classList.add('hidden');
    if (reversePopup) reversePopup.classList.add('hidden');
  },

  addProductAfterClear: function(requestData) {
    console.log('UnifiedPreorderSystem: addProductAfterClear requestData', requestData);
    // Defensive: ensure requestData is always in the correct format
    if (!requestData || !requestData.items || !Array.isArray(requestData.items) || !requestData.items[0] || !requestData.items[0].id) {
      console.error('UnifiedPreorderSystem: Invalid requestData for addProductAfterClear', requestData);
      this.pending = false;
      return;
    }
    if (window.liquidAjaxCart) {
      window.liquidAjaxCart.clear({}, {
        lastCallback: (clearRequestState) => {
          setTimeout(() => {
            window.liquidAjaxCart.add(requestData, {
              lastCallback: (addRequestState) => {
                this.pending = false;
                if (addRequestState.responseData && !addRequestState.responseData.message) {
                  document.body.classList.add('js-show-ajax-cart');
                  closeAllQuickBuyDrawers();
                } else {
                  console.error('UnifiedPreorderSystem: Error adding product:', addRequestState.responseData?.message);
                }
              }
            });
          }, 300);
        }
      });
    } else {
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        if (response.ok) {
          setTimeout(() => {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(requestData)
            }).then(response => response.json())
            .then(data => {
              this.pending = false;
              document.body.classList.add('js-show-ajax-cart');
              closeAllQuickBuyDrawers();
            }).catch(error => {
              this.pending = false;
              console.error('UnifiedPreorderSystem: Error in fallback flow:', error);
            });
          }, 300);
          return;
        }
        throw new Error('Failed to clear cart');
      });
    }
  },

  resetState: function() {
    this.pending = false;
    this.pendingRequestState = null;
    this.cancelled = false;
  }
};


// --- Unified Preorder Mutation ---
function preorderMutation() {
  // Property to mark auto-added preorder companion
  const autoaddedProp = '_autoadded_preorder';
  // The variant ID to auto-add
  const preorderVariant = 52133952487751;
  // Current cart state
  const cart = window.liquidAjaxCart.cart;

  // Check if any item in cart has _preorder true
  const hasPreorder = cart.items.some(item => item.properties && item.properties._preorder === 'true');
  // Find if the auto-added variant is already in cart
  const autoAddedLineItem = cart.items.findIndex(lineItem => {
    return lineItem.variant_id === preorderVariant && lineItem.properties?.[autoaddedProp] === 'Yes';
  });

  if (hasPreorder) {
    // If _preorder is present and the variant is not in cart, add it
    if (autoAddedLineItem === -1) {
      return {
        requests: [
          {
            type: "add",
            body: {
              items: [{
                id: preorderVariant,
                quantity: 1,
                properties: { [autoaddedProp]: "Yes", _preorder: "true" }
              }]
            } 
          }
        ]
      };
    }
  } else {
    // If _preorder is not present but the variant is in cart, remove it
    if (autoAddedLineItem > -1) {
      return {
        requests: [
          {
            type: "change",
            body: {
              line: autoAddedLineItem + 1,
              quantity: 0
            }
          } 
        ]
      };
    }
  }
}


// Register the mutation with Liquid Ajax Cart reliably
function registerPreorderMutationWithRetry(retries = 10, delay = 300) {
  if (window.liquidAjaxCart && typeof window.liquidAjaxCart.conf === 'function') {
    window.liquidAjaxCart.conf('mutations', [preorderMutation]);
    console.log('preorderMutation registered with liquidAjaxCart');
    return;
  }
  if (retries > 0) {
    setTimeout(() => registerPreorderMutationWithRetry(retries - 1, delay), delay);
  } else {
    console.warn('preorderMutation could not be registered: liquidAjaxCart not found');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  registerPreorderMutationWithRetry();
});

// Initialize the unified system when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.UnifiedPreorderSystem.init();
  console.log('Global UnifiedPreorderSystem initialized');
});

// Ensure shadow preorder is removed when it is the only item in the cart
document.addEventListener('liquid-ajax-cart:request-end', function(event) {
  // small delay to allow any internal state updates to settle
  setTimeout(() => {
    const autoaddedProp = '_autoadded_preorder';
    const preorderVariant = 52133952487751;

    const getCart = () => {
      if (window.liquidAjaxCart && window.liquidAjaxCart.cart) return Promise.resolve(window.liquidAjaxCart.cart);
      return fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [] }));
    };

    getCart().then(cart => {
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      // find shadow preorder line item that was auto-added
      const autoIndex = cart.items.findIndex(item => item.variant_id === preorderVariant && item.properties?.[autoaddedProp] === 'Yes');

      // If the autoadded preorder exists and is the only item in the cart, remove it
      if (autoIndex > -1 && cart.items.length === 1) {
        // Attempt to use liquidAjaxCart API if available
        if (window.liquidAjaxCart && typeof window.liquidAjaxCart.change === 'function') {
          window.liquidAjaxCart.change({ line: autoIndex + 1, quantity: 0 }, {
            lastCallback: () => {
              console.log('Removed autoadded preorder because it was the only item in the cart');
            }
          });
        } else {
          // Fallback to direct fetch change
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: autoIndex + 1, quantity: 0 })
          }).then(() => {
            console.log('Removed autoadded preorder (fallback) because it was the only item in the cart');
          }).catch(err => {
            console.error('Failed to remove autoadded preorder (fallback):', err);
          });
        }
      }
    });
  }, 50);
});